// extracted by mini-css-extract-plugin
export default {"minifiedProgress":"styles_minifiedProgress__VFmtC","timerAndProgress":"styles_timerAndProgress__9Xiwt"};